import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function IOTDataPage() {

  const [rows, setRows] = useState([]);
  const [devices, setDevices] = useState([]);

  const [data, setData] = useState({
    device: "",
    temperature: "",
    humidity: "",
    latitude: "",
    longitude: ""
  });

  useEffect(() => {
    fetchData();
    fetchDevices();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "iot-data/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchDevices = () => {
    axios.get(baseUrl + "iot-devices/")
      .then(res => {
        setDevices(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.device) {
      Swal.fire("Error", "Device is required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("device", data.device);
    _formData.append("temperature", data.temperature);
    _formData.append("humidity", data.humidity);
    _formData.append("latitude", data.latitude);
    _formData.append("longitude", data.longitude);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);
    axios.post(baseUrl + "iot-data/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {

      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "Data Saved",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          device: "",
          temperature: "",
          humidity: "",
          latitude: "",
          longitude: ""
        });

        fetchData();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Delete this data record?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "iot-data/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Record deleted", "success");
            fetchData();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "device",
      headerName: "Device",
      flex: 1,
      renderCell: (params) => params.row.device?.device_id || "Unknown"

    },
    { field: "temperature", headerName: "Temp (°C)", flex: 1 },
    { field: "humidity", headerName: "Humidity (%)", flex: 1 },
    { field: "latitude", headerName: "Latitude", flex: 1 },
    { field: "longitude", headerName: "Longitude", flex: 1 },
    { field: "timestamp", headerName: "Timestamp", flex: 1 },

    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/iot-data/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning"
        >
          Edit
        </Link>
      ),
      width: 120
    },

    {
      field: "delete",
      headerName: "Action",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm ms-1"
        >
          <i className="fa-solid fa-trash-can"></i>
        </button>
      ),
      width: 120
    }
  ];

useEffect(() => {

  fetchData();

  const socket = new WebSocket("ws://localhost:8000/ws/iot/");

  socket.onmessage = function(event) {
    const liveData = JSON.parse(event.data);

    setRows(prev => [
      {
        id: Date.now(),
        device_id: liveData.device,
        temperature: liveData.temperature,
        humidity: liveData.humidity,
        latitude: liveData.latitude,
        longitude: liveData.longitude,
        timestamp: new Date().toISOString()
      },
      ...prev
    ]);
  };

  socket.onclose = function() {
    console.log("WebSocket disconnected");
  };

  return () => socket.close();

}, []);

  return (
    <div className="container mt-4">

      {/* Form Card */}
      <div className="card p-4 mb-4">
        <h4>Add IoT Data</h4>

        <select
          className="form-control mt-3"
          name="device"
          value={data.device}
          onChange={inputHandler}
        >
          <option value="">Select Device</option>
          {devices.map(d => (
            <option key={d.id} value={d.id}>
              {d.device_id}
            </option>
          ))}
        </select>

        <input
          type="number"
          step="0.01"
          className="form-control mt-3"
          placeholder="Temperature"
          name="temperature"
          value={data.temperature}
          onChange={inputHandler}
        />

        <input
          type="number"
          step="0.01"
          className="form-control mt-3"
          placeholder="Humidity"
          name="humidity"
          value={data.humidity}
          onChange={inputHandler}
        />

        <input
          type="number"
          step="0.000001"
          className="form-control mt-3"
          placeholder="Latitude"
          name="latitude"
          value={data.latitude}
          onChange={inputHandler}
        />

        <input
          type="number"
          step="0.000001"
          className="form-control mt-3"
          placeholder="Longitude"
          name="longitude"
          value={data.longitude}
          onChange={inputHandler}
        />

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default IOTDataPage;
